export const useContactName = controller => {
  Object.assign(controller, {
    updateTitle() {
      let title = this.defaultTitleValue
      if (this.firstNameTarget.value || this.lastNameTarget.value) {
        title = [this.firstNameTarget.value, this.lastNameTarget.value].filter(Boolean).join(' ')
      }
      this.titleTarget.textContent = title
    }
  })
}
